export default "__VITE_ASSET__2qujAOP0__"